import axios from 'axios';
import type { ISubscribeAnsweringServiceBody } from '@/app-package';
import { AnsweringSubscriptionDoc } from '@bb/domain/dist/schemas';

/**
 * Creates an answering service subscription for a user/org.
 * A billing profile will be created or updated with the provided billing information.
 */
const createAnsweringServiceSubscription = async (
  params: ISubscribeAnsweringServiceBody,
): Promise<AnsweringSubscriptionDoc> => {
  const { data } = await axios.post<AnsweringSubscriptionDoc>(
    '/answering_service/subscribe',
    params,
  );
  return data;
};

export default createAnsweringServiceSubscription;
